const forms = document.querySelectorAll('[data-form]');

for (const form of forms) {
  const filters = form.querySelectorAll('[data-filter]');
  const items = form.nextElementSibling.querySelectorAll('[data-item]');

  const matches = (filter, state, item) => {
    if (state[filter].length) {
      let match = false;

      for (const value of state[filter]) {
        const test = item.getAttribute(`data-${filter}`) ? item.getAttribute(`data-${filter}`).split(' ').filter(i => i) : item.innerText;

        if (test.includes(value)) {
          match = true;
        }
      }

      return match;
    } else {
      return true;
    }
  };

  const update = () => {
    let state = {
      search: [],
      outcome: [],
      age_group: [],
      time: [],
      type: [],
    };

    const data = [...new FormData(form)].filter(([_, v]) => v);

    for (const [k, v] of data) {
      state[k].push(v);
    }

    for (const item of items) {
      if (matches('search', state, item) && matches('outcome', state, item) && matches('age_group', state, item) && matches('time', state, item) && matches('type', state, item)) {
        item.removeAttribute('data-inactive');
      } else {
        item.setAttribute('data-inactive', '');
      }
    }
  };

  form.addEventListener('submit', (e) => e.preventDefault());
  form.addEventListener('reset', () => setTimeout(update));
  for (const filter of filters) {
    filter.addEventListener('input', update);
  }
  window.addEventListener('load', update);
}

const toggles = document.querySelectorAll('[data-toggle]');

for (const toggle of toggles) {
  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';

    toggle.setAttribute('aria-expanded', !expanded);
  });

  document.addEventListener('click', (e) => {
    if (!toggle.parentNode.contains(e.target)) {
      toggle.setAttribute('aria-expanded', 'false');
    }
  })
}
